import React from 'react';
import styled from 'styled-components';
import {fontSize} from '../mixins';


const StyledLine = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  ${fontSize(16)};
  line-height: 22px;
  color: #848484;
  
  &::before,
  &::after {
    content: '';
    width: 30%;
    height: 1px;
    background: #E9E9E9;
    position: absolute;
    top: 50%;
    right: 0;
  }
  
  &::before {
    right: unset;
    left: 0;
  }
`


const Separator = ({children}) => {
    return (
        <StyledLine>{children}</StyledLine>
    )
};


export default Separator;